import {
  DropDown,
  SearchBar,
  NewSiteButton,
  Card,
} from "../components/textField";
import TopNav from "../components/topnav";
import EnhancedTable from "../components/newTable";
import { useState, useEffect, useMemo } from "react";
import SiteModal from "../components/siteCreationModal";
import { useBackgroundAIJobs } from "../components/backgroundAIJobContext";
import { content } from "../utils/data";
import {
  getDocuments,
  createBorrowal,
  getBorrowalUsers,
  returnBorrowal,
  getStatesDropDown,
  getLocationDropDown,
  getSiteDropDown,
  getDocumentCatgory,
  getUploadAllDocumentCategory,
  getDocumentType,
  getAllDocumentType,
  getBorrowals,
  reportLog,
  getTranslation,
  getSummary,
  getTranslationFile,
  getSummaryFile,
  decideTranslation,
  decideSummary,
  getPdf,
} from "../api/serverApi";
import DocumentModal from "../components/documentModal";
import FileDocumentViewModal from "../components/fileDocumentViewModal";
import { BorrrowalForm, ReturnForm } from "../components/dropdowns";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { useCookies } from "react-cookie";
import Spinner from "../components/spinner";
import StatusModal from "../components/statusModal";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNavigate } from "react-router-dom";
import CourtHistoryModal from "../components/courtHistory";
import { useMsal } from "@azure/msal-react";
import { getValidAccessToken } from "../services/garphService";
import SidebarDropdown from "../components/sideBar";
import * as microsoftTeams from "@microsoft/teams-js";
import BorrowIcon from "../assests/Bo.png";
import ReturnIcon from "../assests/Re.png";
import SummaryIcon from "../assests/Su.png";
import TranslationIcon from "../assests/Tr.png";

import PsIcon from "../assests/Ps.png";
import PtIcon from "../assests/Pt.png";
import TsIcon from "../assests/Ts.png";
import SmIcon from "../assests/Sm.png";
import TgIcon from "../assests/Tg.png";
import SgIcon from "../assests/Sg.png";
import TranslationModal from "../components/approvalTranslationModal";
import SummaryModal from "../components/approvalSummaryModal";
const File = () => {
  const {
    translationJobs,
    startTranslationJob,
    clearTranslationJob,
    summaryJobs,
    startSummaryJob,
    clearSummaryJob,
  } = useBackgroundAIJobs();

  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedMetadata, setSelectedMetadata] = useState(null);
  const [drillLevel, setDrillLevel] = useState("state");
  const [selectedState, setSelectedState] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const [borrowal, setBorrowal] = useState([]);
  const [user, setUsers] = useState([]);
  const [userId, setUserId] = useState("");
  const [selectedDocumenCapturetId, setSelectedCaputureDocumentId] =
    useState(null);
  const [getState, setGetState] = useState([]);
  const [getLocation, setGetLocation] = useState([]);
  const [getSite, setGetSite] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const [selectedSiteId, setSelecteSiteId] = useState("");
  const [documentCategory, setDocumentCategory] = useState([]);
  const [documentType, setDocumentType] = useState([]);
  const [selectedDocumentCategory, setSelectedDocumentCategory] = useState("");
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [borrowalStatus, setBorrowalStatus] = useState([]);
  const [isModalOpen, setisModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [selectedDocumentName, setSelectedDocumentName] = useState("");
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const [translationOpen, setTranslationOpen] = useState(false);
  const [translationPreviewUrl, setTranslationPreviewUrl] = useState("");

  const [existingTranslationPreviewUrl, setExistingTranslationPreviewUrl] =
    useState("");
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [summaryResponse, setSummaryResponse] = useState(null);

  const [viewPdfOpen, setViewPdfOpen] = useState(false);
  const [viewPdfTitle, setViewPdfTitle] = useState("");
  const [viewPdfSharePointId, setViewPdfSharePointId] = useState("");
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const [loading, setLoading] = useState("");
  const [cookies, setCookie] = useCookies([
    "email",
    "firstName",
    "lastName",
    "roleName",
    "roleId",
    "accessToken",
    "fullname",
  ]);
  const role = cookies.permissions;
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [selectedOsNumber, setSelectedOsNumber] = useState(null);

  const openModalWithOs = (os_number) => {
    setSelectedOsNumber(os_number);
    setOpenHistoryModal(true);
  };
  // Utility to detect Teams context
  const isInTeams = () => {
    try {
      return window.parent !== window.self;
    } catch {
      return false;
    }
  };

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }
      const response = await getDocuments(token);

      response.data.forEach((doc) => {
        console.log(`Document ${doc.document_id}:`, {
          translation_status: doc.translation_status,
          translation_accepted: doc.translation_accepted,
          summary_status: doc.summary_status,
          summary_accepted: doc.summary_accepted,
        });
      });

      setResponseData(response.data);
    } catch (error) {
      const message =
        error?.response?.data?.detail || "An unexpected error occurred";
      setResponseMessage(message);
      setisModalOpen(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  const getUniqueStates = () => [
    ...new Set(responseData.map((item) => item.state_name)),
  ];

  const getLocationsForState = (state) => [
    ...new Set(
      responseData
        .filter((item) => item.state_name === state && item.location_name)
        .map((item) => item.location_name),
    ),
  ];

  const getSitesForLocation = (state, location) =>
    responseData
      .filter(
        (item) => item.state_name === state && item.location_name === location,
      )
      .map((item) => item.site_name);

  const getSitesForStateWithoutLocations = (state) =>
    responseData
      .filter((item) => item.state_name === state && !item.location_name)
      .map((item) => item.site_name);

  const handleViewTranslation = async (documentId) => {
    try {
      let token;

      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      const response = await getTranslation(documentId, token);

      const data = response?.data;

      if (!data?.sharepoint_file_id) {
        return;
      }

      setViewPdfTitle("Translated Document");
      setViewPdfSharePointId(data.sharepoint_file_id);
      setViewPdfOpen(true);
    } catch (error) {
      console.error("Error fetching translation:", error);
    }
  };
  const handleViewSummary = async (documentId) => {
    try {
      let token;

      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      const response = await getSummary(documentId, token);

      const data = response?.data;

      if (!data?.sharepoint_file_id) {
        return;
      }

      setViewPdfTitle("Summarized Document");
      setViewPdfSharePointId(data.sharepoint_file_id);
      setViewPdfOpen(true);
    } catch (error) {}
  };
  const handleTranslateAgain = async (documentId, documentName) => {
    try {
      if (translationJobs[documentId]?.status === "processing") {
        return;
      }

      await startTranslationJob(documentId, documentName);

      setResponseMessage(
        "Translation started successfully. You can continue working.",
      );
      setIsSuccess(true);
      setisModalOpen(true);
    } catch (error) {
      console.error("Failed to start translation:", error);

      const message =
        error?.response?.data?.detail ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to start translation.";

      setResponseMessage(message);
      setIsSuccess(false);
      setisModalOpen(true);
    }
  };

  const handlePreviewTranslation = (documentId) => {
    const job = translationJobs[documentId];

    if (job?.status !== "done") {
      return;
    }

    setSelectedDocumentId(documentId);
    setTranslationPreviewUrl(job.download_url || "");
    setTranslationOpen(true);
  };

  const handlePreviewSummary = (documentId) => {
    const job = summaryJobs[documentId];

    if (job?.status !== "done") {
      return;
    }

    setSelectedDocumentId(documentId);
    setSummaryResponse(job.result || null);
    setSummaryOpen(true);
  };

  const handleTranslationDecision = async (decision) => {
    const documentId = selectedDocumentId;

    try {
      let token;

      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      const data = {
        decision,
      };

      if (decision === "Accept") {
        if (!translationPreviewUrl) {
          throw new Error("Translation download URL is not available.");
        }

        data.download_url = translationPreviewUrl;
      }

      await decideTranslation(documentId, data, token);

      // Clear temporary background job
      clearTranslationJob(documentId);

      setTranslationOpen(false);
      setTranslationPreviewUrl("");
      setSelectedDocumentId(null);

      // Refresh Files API so translation_accepted
      // and SharePoint details come from backend
      await fetchDocuments();

      setResponseMessage(
        `Translation ${
          decision === "Accept" ? "saved" : "rejected"
        } successfully.`,
      );

      setIsSuccess(true);
      setisModalOpen(true);
    } catch (error) {
      console.error("Translation decision failed:", error);

      setResponseMessage(
        error?.response?.data?.detail ||
          error?.response?.data?.error ||
          error?.message ||
          "Failed to save translation.",
      );

      setIsSuccess(false);
      setisModalOpen(true);
    }
  };
  const handleSummaryDecision = async (decision) => {
    const documentId = selectedDocumentId;

    try {
      let token;

      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      const downloadUrl =
        summaryJobs?.[documentId]?.result?.download_url ||
        summaryResponse?.download_url ||
        "";

      const data = {
        decision,
      };

      if (decision === "Accept") {
        if (!downloadUrl) {
          throw new Error("Summary download URL is not available.");
        }

        data.download_url = downloadUrl;
      }

      await decideSummary(documentId, data, token);

      // Clear temporary background job
      clearSummaryJob(documentId);

      setSummaryOpen(false);
      setSummaryResponse(null);
      setSelectedDocumentId(null);

      // Refresh Files API
      await fetchDocuments();

      setResponseMessage(
        `Summary ${decision === "Accept" ? "saved" : "rejected"} successfully.`,
      );

      setIsSuccess(true);
      setisModalOpen(true);
    } catch (error) {
      console.error("Summary decision failed:", error);

      setResponseMessage(
        error?.response?.data?.detail ||
          error?.response?.data?.error ||
          error?.message ||
          "Failed to save summary.",
      );

      setIsSuccess(false);
      setisModalOpen(true);
    }
  };

  const handleSummaryAgain = async (documentId, documentName) => {
    try {
      if (summaryJobs[documentId]?.status === "processing") {
        return;
      }

      await startSummaryJob(documentId, documentName);

      setResponseMessage(
        "Summary started successfully. You can continue working.",
      );
      setIsSuccess(true);
      setisModalOpen(true);
    } catch (error) {
      console.error("Failed to start summary:", error);

      const message =
        error?.response?.data?.detail ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to start summary.";

      setResponseMessage(message);
      setIsSuccess(false);
      setisModalOpen(true);
    }
  };
  const handleBorrowal = (id, name) => {
    setSelectedDocumentId(id);
    setSelectedDocumentName(name);
    setOpen(true);
  };
  const handleReturn = (id, name) => {
    setSelectedDocumentId(id);
    setSelectedDocumentName(name);
    setOpenModal(true);
  };

  const rowsWithActions = useMemo(() => {
    if (!selectedSite) return [];

    return responseData
      .filter((item) => item.site_name === selectedSite)
      .map(
        ({
          site_id,
          document_name,
          sharepoint_id,
          category_id,
          document_type_id,
          document_id,
          uploaded_at,
          unique_survey_no,
          start_year,
          end_year,
          valid_until,
          saledeed_no,
          seller_name,
          receipt_number,
          entity_name,
          khata,
          amount,
          other_document_title,
          reference_document_title,
          reference_document_description,
          other_document_description,
          grand_parent_document_title,
          grand_parent_document_description,
          parent_document_title,
          parent_document_description,
          site_name,
          state_name,
          location_name,
          description,
          os_number,
          document_copy_type,
          document_category,
          box_number,
          url,
          document_type,
          lease_deed_date,
          lease_no,
          purchase_date,
          area_under_litigation_gunta,
          cnr_number,
          area_under_litigation_acre,
          approved_by,

          translation_status,
          translation_accepted,
          summary_status,
          summary_accepted,
        }) => {
          const formattedDate = uploaded_at
            ? new Date(uploaded_at)
                .toLocaleDateString("en-GB")
                .replace(/\//g, "-")
            : "";

          const canBorrowReturn =
            role === "Admin" ||
            role === "State Admin" ||
            role === "Location Admin";

          const canViewTranslatedSummary =
            role === "Spoc" || role === "End User";
          const isBorrowed = borrowalStatus?.[document_id];

          const document_name_text = document_name || "";
          const searchText = [
            document_name_text,
            description,
            state_name,
            site_name,
            location_name,
            document_category,
            document_type,
            os_number,
            other_document_title,
            reference_document_title,
            parent_document_title,
            grand_parent_document_title,
            approved_by,
          ]
            .join(" ")
            .replace(/\s+/g, " ")
            .toLowerCase();

          return {
            key: site_id,
            site_name,
            state_name,
            approved_by,
            document_id,
            entity_name,
            area_under_litigation_gunta,
            area_under_litigation_acre,
            url,
            category_id,
            document_type_id,
            location_name,
            description,
            cnr_number,
            uploaded_at: formattedDate,
            box_number,
            document_category,
            seller_name,
            document_type,
            document_name_text,
            searchText,
            lease_deed_date,
            lease_no,
            purchase_date,
            reference_document_title,
            reference_document_description,
            grand_parent_document_description,
            grand_parent_document_title,
            parent_document_title,
            parent_document_description,

            other_document_title:
              document_type === "Other Litigation Documents" ||
              document_type === "Other Land Documents" ||
              document_type === "Other Pre & Post Construction Documents"
                ? other_document_title
                : document_type === "Reference Document"
                  ? reference_document_title
                  : document_type === "Parent Document"
                    ? parent_document_title
                    : document_type === "Grand Parent Document"
                      ? grand_parent_document_title
                      : null,
            os_number: (
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {os_number}
                {document_category === "Litigation" && (
                  <Button
                    size="small"
                    title="Court Case History"
                    style={{
                      borderRadius: "50%",
                      minWidth: "32px",
                      width: "32px",
                      height: "32px",
                      padding: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => openModalWithOs(os_number)}
                  >
                    <InfoOutlinedIcon fontSize="small" style={{ margin: 0 }} />
                  </Button>
                )}
              </div>
            ),
            document_name: (
              <a
                href="#"
                rel="noopener noreferrer"
                style={{
                  color: "#1a0dab",
                  textDecoration: "underline",
                  wordBreak: "break-word",
                  maxWidth: "150px",
                  display: "inline-block",
                  whiteSpace: "normal",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedMetadata({
                    site_id,
                    document_name,
                    sharepoint_id,
                    uploaded_at,
                    unique_survey_no: Array.isArray(unique_survey_no)
                      ? unique_survey_no.join(", ")
                      : unique_survey_no,
                    start_year,
                    end_year,
                    valid_until,
                    saledeed_no,
                    seller_name,
                    receipt_number,
                    khata,
                    url,
                    amount,
                    other_document_title,
                    other_document_description,
                    reference_document_title,
                    reference_document_description,
                    grand_parent_document_title,
                    grand_parent_document_description,
                    parent_document_title,
                    parent_document_description,
                    area_under_litigation_gunta,
                    area_under_litigation_acre,
                    site_name,
                    state_name,
                    entity_name,
                    os_number,
                    location_name,
                    document_type,
                    document_copy_type,
                    document_category,
                    box_number,
                    lease_deed_date,
                    lease_no,
                    cnr_number,
                    purchase_date,
                    uploaded_at: formattedDate,
                  });
                  setSelectedCaputureDocumentId(document_id);
                  setModalOpen(true);
                }}
              >
                {document_name}
              </a>
            ),

            action:
              canBorrowReturn || canViewTranslatedSummary ? (
                <div className="flex flex-col gap-2">
                  {/* Borrow / Return */}
                  {canBorrowReturn && (
                    <div className="flex gap-2 items-center">
                      {/* Borrow */}
                      <img
                        src={BorrowIcon}
                        alt="Borrow"
                        title="Borrow"
                        onClick={() => {
                          if (!isBorrowed) {
                            handleBorrowal(document_id, document_name);
                          }
                        }}
                        style={{
                          width: "24px",
                          cursor: isBorrowed ? "not-allowed" : "pointer",
                          opacity: isBorrowed ? 0.5 : 1,
                        }}
                      />

                      {/* Return */}
                      <img
                        src={ReturnIcon}
                        alt="Return"
                        title="Return"
                        onClick={() => handleReturn(document_id, document_name)}
                        style={{
                          width: "24px",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  )}

                  {/* Translated / Summarized */}
                  {canViewTranslatedSummary && (
                    <div className="flex gap-2 items-center">
                      {/* Translated */}
                      {translation_accepted === true && (
                        <img
                          src={TranslationIcon}
                          alt="Translated"
                          title="Translated"
                          onClick={() => handleViewTranslation(document_id)}
                          style={{
                            width: "24px",
                            cursor: "pointer",
                          }}
                        />
                      )}

                      {/* Summarized */}
                      {summary_accepted === true && (
                        <img
                          src={SummaryIcon}
                          alt="Summarized"
                          title="Summarized"
                          onClick={() => handleViewSummary(document_id)}
                          style={{
                            width: "24px",
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </div>
                  )}

                  {/* Generate Again Buttons */}
                  {canBorrowReturn && (
                    <div className="flex gap-2">
                      {/* Translate Again */}
                      <img
                        src={
                          translationJobs[document_id]?.status === "processing"
                            ? TgIcon
                            : translationJobs[document_id]?.status === "done"
                              ? PtIcon
                              : TsIcon
                        }
                        alt={
                          translationJobs[document_id]?.status === "processing"
                            ? "Translating"
                            : translationJobs[document_id]?.status === "done"
                              ? "Preview Translate"
                              : "Translate"
                        }
                        title={
                          translationJobs[document_id]?.status === "processing"
                            ? "Translating..."
                            : translationJobs[document_id]?.status === "done"
                              ? "Preview Translate"
                              : "Translate"
                        }
                        onClick={async () => {
                          const job = translationJobs[document_id];

                          // Still translating → don't do anything
                          if (job?.status === "processing") {
                            return;
                          }

                          // Translation completed → open preview
                          if (job?.status === "done") {
                            setSelectedDocumentId(document_id);
                            setTranslationPreviewUrl(job.download_url || "");
                            setExistingTranslationPreviewUrl("");
                            setTranslationOpen(true);
                            return;
                          }

                          // Already accepted → open existing translation
                          if (translation_accepted === true) {
                            try {
                              let token;

                              if (isInTeams()) {
                                token = await new Promise((resolve, reject) => {
                                  microsoftTeams.authentication.getAuthToken({
                                    successCallback: resolve,
                                    failureCallback: reject,
                                    resources: ["https://graph.microsoft.com"],
                                  });
                                });
                              } else {
                                token = await getValidAccessToken(
                                  instance,
                                  accounts,
                                );
                              }

                              const response = await getTranslationFile(
                                document_id,
                                token,
                              );

                              if (existingTranslationPreviewUrl) {
                                URL.revokeObjectURL(
                                  existingTranslationPreviewUrl,
                                );
                              }

                              const existingUrl = URL.createObjectURL(
                                response.data,
                              );

                              setSelectedDocumentId(document_id);
                              setTranslationPreviewUrl("");
                              setExistingTranslationPreviewUrl(existingUrl);
                              setTranslationOpen(true);

                              return;
                            } catch (error) {
                              console.error(
                                "Failed to load existing translation:",
                                error,
                              );

                              setResponseMessage(
                                error?.response?.data?.detail ||
                                  error?.response?.data?.error ||
                                  error?.message ||
                                  "Failed to load existing translation.",
                              );

                              setIsSuccess(false);
                              setisModalOpen(true);

                              return;
                            }
                          }

                          // First time / rejected → start translation
                          handleTranslateAgain(document_id, document_name);
                        }}
                        style={{
                          width: "24px",
                          // height: "40px",
                          objectFit: "contain",
                          cursor:
                            translationJobs[document_id]?.status ===
                            "processing"
                              ? "default"
                              : "pointer",
                        }}
                      />
                      {/* summary */}
                      <img
                        src={
                          summaryJobs[document_id]?.status === "processing"
                            ? SgIcon
                            : summaryJobs[document_id]?.status === "done"
                              ? PsIcon
                              : SmIcon
                        }
                        alt={
                          summaryJobs[document_id]?.status === "processing"
                            ? "Summarizing"
                            : summaryJobs[document_id]?.status === "done"
                              ? "Preview Summary"
                              : "Summary"
                        }
                        title={
                          summaryJobs[document_id]?.status === "processing"
                            ? "Summarizing..."
                            : summaryJobs[document_id]?.status === "done"
                              ? "Preview Summary"
                              : "Summary"
                        }
                        onClick={() => {
                          const job = summaryJobs[document_id];

                          // LLM is currently working
                          if (job?.status === "processing") {
                            return;
                          }

                          // Summary completed → open preview
                          if (job?.status === "done") {
                            handlePreviewSummary(document_id);
                            return;
                          }

                          // Existing accepted summary → open existing summary
                          if (summary_accepted === true) {
                            setSelectedDocumentId(document_id);
                            setSummaryResponse(null);
                            setSummaryOpen(true);
                            return;
                          }

                          // First time / rejected → start summary
                          handleSummaryAgain(document_id, document_name);
                        }}
                        style={{
                          width: "24px",
                          // height: "40px",
                          objectFit: "contain",
                          cursor:
                            summaryJobs[document_id]?.status === "processing"
                              ? "default"
                              : "pointer",
                        }}
                      />
                    </div>
                  )}
                </div>
              ) : null,
          };
        },
      );
  }, [
    responseData,
    selectedSite,
    borrowalStatus,
    role,
    translationJobs,
    summaryJobs,
  ]);

  useEffect(() => {
    const fetchReportLog = async () => {
      try {
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await reportLog(selectedDocumenCapturetId, token);
      } catch (error) {}
    };

    if (selectedDocumenCapturetId) {
      fetchReportLog();
    }
  }, [selectedDocumenCapturetId]); // corrected dependency variable spelling if needed

  useEffect(() => {
    const fetchBorrowalUsers = async () => {
      try {
        let token;

        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }

        const response = await getBorrowalUsers(token);

        setUsers(response.data);
        setUserId("");
      } catch (error) {}
    };

    fetchBorrowalUsers();
  }, []);

  const handleSubmit = async () => {
    const data = {
      borrowed_by: userId,
    };

    try {
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      await createBorrowal(selectedDocumentId, data, token);

      setOpen(false);
      setBorrowalStatus((prev) => ({
        ...prev,
        [selectedDocumentId]: true,
      }));
      fetchDocuments();
      setOpenModal(false);
      reset();

      setResponseMessage("Borrowal created successfully.");
      setIsSuccess(true);
      setisModalOpen(true);
    } catch (error) {
      const details = error?.response?.data?.detail;
      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(error?.response?.data?.detail);
      }

      setIsSuccess(false);
      setisModalOpen(true);
      setOpen(false);
      setOpenModal(false);
      reset();
    }
  };

  const reset = () => {
    setUserId("");
  };

  const BorrowalReturn = async () => {
    const documentIdInt = parseInt(selectedDocumentId, 10);

    try {
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      await returnBorrowal(documentIdInt, token);

      setOpenModal(false);
      setBorrowalStatus((prev) => {
        const updated = { ...prev };
        delete updated[documentIdInt];
        return updated;
      });
      fetchDocuments();

      setResponseMessage("Borrowal returned successfully.");
      setIsSuccess(true);
      setisModalOpen(true);
    } catch (error) {
      console.error("Error returning borrowal:", error);

      const details = error?.response?.data?.detail;
      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(error?.response?.data?.detail);
      }

      setIsSuccess(false);
      setisModalOpen(true);
      setOpenModal(false);
    }
  };

  useEffect(() => {
    if (selectedDocumentCategory) {
      getAllDocumentType({ category_id: selectedDocumentCategory })
        .then((response) => {
          setDocumentType(response.data);
          setSelectedDocumentType("");
          console.log(response);
        })
        .catch((error) => {
          // Handle error
          // setshowModal(true);
          // setModalTitle("Something went wrong, Please try again");
          console.error("Error:", error);
          // setLoading(false);
        });
    } else {
      setSelectedDocumentType("");
    }
  }, [selectedDocumentCategory]);

  useEffect(() => {
    // setLoading(true);
    getUploadAllDocumentCategory()
      .then((response) => {
        // Handle succesasful response
        setDocumentCategory(response.data);
        setSelectedDocumentCategory("");
        console.log(response);

        // setLoading(false);
      })
      .catch((error) => {
        // Handle error
        // setshowModal(true);
        // setModalTitle("Something went wrong, Please try again");
        console.error("Error:", error);
        // setLoading(false);
      });
  }, []);

  useEffect(() => {
    const fetchBorrowals = async () => {
      setLoading(true);
      try {
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getBorrowals(token);

        // Create a lookup object with document_id as key
        const borrowalMap = {};

        response.data.forEach((item) => {
          if (item.status === "borrowed") {
            borrowalMap[item.document_id] = true;
          }
        });

        setBorrowalStatus(borrowalMap);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBorrowals();
  }, []);

  const filteredRows = useMemo(() => {
    const normalizedSearch = searchQuery
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();

    return rowsWithActions.filter((row) => {
      const matchesCategory =
        selectedDocumentCategory === 999 || !selectedDocumentCategory
          ? true
          : row.category_id === selectedDocumentCategory;

      const matchesType =
        selectedDocumentType === 999 || !selectedDocumentType
          ? true
          : row.document_type_id === selectedDocumentType;

      const matchesSearch = normalizedSearch
        ? (row.searchText || "").includes(normalizedSearch)
        : true;

      return matchesCategory && matchesType && matchesSearch;
    });
  }, [
    rowsWithActions,
    selectedDocumentCategory,
    selectedDocumentType,
    searchQuery,
  ]);

  return (
    <>
      <TopNav />

      <div className="flex overflow-hidden">
        {/* Sidebar */}
        <div className="w-64 flex-shrink-0 border-r">
          <SidebarDropdown
            getUniqueStates={getUniqueStates}
            getLocationsForState={getLocationsForState}
            getSitesForLocation={getSitesForLocation}
            getSitesForStateWithoutLocations={getSitesForStateWithoutLocations}
            onSelectSite={(state, location, site) => {
              setSelectedState(state);
              setSelectedLocation(location);
              setSelectedSite(site);
              setSearchQuery("");
              console.log("Selected:", { state, location, site });
            }}
          />
        </div>
        {/* Scrollable content */}
        <div className="flex-1 overflow-y-auto scrollbar-hide">
          {/* Breadcrumb */}
          <div className="px-6 py-2 font-bold text-2xl flex gap-2 flex-wrap">
            Files
            {selectedState && (
              <>
                <span>{">"}</span>
                <span>{selectedState}</span>
              </>
            )}
            {selectedLocation && (
              <>
                <span>{">"}</span>
                <span>{selectedLocation}</span>
              </>
            )}
            {selectedSite && (
              <>
                <span>{">"}</span>
                <span className="text-gray-500">{selectedSite}</span>
              </>
            )}
          </div>

          {/* Filters */}
          {selectedSite && (
            <div className="flex flex-wrap px-4 md:px-[35px] gap-2 md:gap-x-3 items-center">
              <div className="w-full sm:w-auto flex-shrink-0">
                <SearchBar
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <div className="w-full sm:w-auto flex-shrink-0">
                <DropDown
                  title="Document Category"
                  placeholder="None"
                  responseData={documentCategory}
                  labelKey="name"
                  valueKey="category_id"
                  onChange={(e) =>
                    setSelectedDocumentCategory(Number(e.target.value))
                  }
                  value={selectedDocumentCategory}
                />
              </div>

              <div className="w-full sm:w-auto flex-shrink-0">
                <DropDown
                  title="Document Type"
                  placeholder="None"
                  responseData={documentType}
                  labelKey="name"
                  valueKey="document_type_id"
                  onChange={(e) =>
                    setSelectedDocumentType(Number(e.target.value))
                  }
                  value={selectedDocumentType}
                />
              </div>
              <div className="w-full sm:w-auto flex-shrink-0">
                <Button
                  variant="contained"
                  onClick={() => {
                    setSelectedStateId(null);
                    setSelectedLocationId(null);
                    setSelecteSiteId(null);
                    setSelectedDocumentCategory(null);
                    setSelectedDocumentType(null);
                    setSearchQuery("");
                  }}
                  sx={{
                    backgroundColor: "#1381B5",
                    "&:hover": { backgroundColor: "#0f6c99" },
                    width: "95px",
                    height: "40px",
                    fontSize: "10px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Clear All
                </Button>
              </div>
            </div>
          )}
          {selectedSite &&
            (() => {
              let dynamicHeaders = [...content.tableColumn];
              if (role !== "Spoc" && role !== "End User") {
                dynamicHeaders = dynamicHeaders.filter(
                  (col) => col.id !== "approved_by",
                );
              }

              // 1. Get selected category & type names
              const selectedCategoryName = documentCategory.find(
                (d) => d.category_id === selectedDocumentCategory,
              )?.name;

              const selectedTypeName = documentType.find(
                (d) => d.document_type_id === selectedDocumentType,
              )?.name;

              // 2. Hide os_number column for specific categories
              if (
                ["Land Documents", "Pre & Post Construction"].includes(
                  selectedCategoryName,
                )
              ) {
                dynamicHeaders = dynamicHeaders.filter(
                  (col) => col.id !== "os_number",
                );
              }

              // 3. Decide when to show other_document_title
              const shouldShowOtherDocTitle =
                (!selectedDocumentCategory && !selectedDocumentType) || // no dropdown selected
                (selectedCategoryName === "Land Documents" &&
                  selectedTypeName === "Other Land Documents") ||
                (selectedCategoryName === "Litigation" &&
                  selectedTypeName === "Other Litigation Documents") ||
                (selectedCategoryName === "Pre & Post Construction" &&
                  selectedTypeName ===
                    "Other Pre & Post Construction Documents") ||
                (selectedCategoryName === "Land Documents" &&
                  selectedTypeName === "Reference Document") ||
                (selectedCategoryName === "Land Documents" &&
                  selectedTypeName === "Parent Document") ||
                (selectedCategoryName === "Land Documents" &&
                  selectedTypeName === "Grand Parent Document");

              if (shouldShowOtherDocTitle) {
                const actionIndex = dynamicHeaders.findIndex(
                  (col) => col.id === "action",
                );

                let newColumn = {
                  id: "other_document_title",
                  label: "Document Title",

                  width: "12.5%",
                };

                // 👇 Special case for Reference Document
                if (
                  selectedCategoryName === "Land Documents" &&
                  selectedTypeName === "Reference Document"
                ) {
                  newColumn.id = "reference_document_title";
                }
                //-----------------------------------------
                if (
                  selectedCategoryName === "Land Documents" &&
                  selectedTypeName === "Grand Parent Document"
                ) {
                  newColumn.id = "grand_parent_document_title"; // stays same but explicitly handled
                }
                // ✅ Parent mapping (ADD THIS)
                if (
                  selectedCategoryName === "Land Documents" &&
                  selectedTypeName === "Parent Document"
                ) {
                  newColumn.id = "parent_document_title"; // stays same but explicitly handled
                }

                if (actionIndex !== -1) {
                  dynamicHeaders.splice(actionIndex, 0, newColumn);
                } else {
                  dynamicHeaders.push(newColumn);
                }
              }
              return (
                <div className="py-2 px-[35px] overflow-x-auto">
                  <EnhancedTable rows={filteredRows} header={dynamicHeaders} />
                </div>
              );
            })()}
        </div>
        {/* Modals */}
        <SiteModal
          title="Borrowal"
          open={open}
          handleClose={() => setOpen(false)}
          handleSubmit={handleSubmit}
          formContent={
            <BorrrowalForm
              documentId={selectedDocumentName}
              responseDataBorrowal={user}
              borrowal="full_name"
              borrowalId="user_id"
              userName={userId}
              onChangeBorrowal={(e) => {
                const value = parseInt(e.target.value, 10);
                setUserId(isNaN(value) ? null : value);
              }}
            />
          }
        />
        <SiteModal
          title="Return"
          open={openModal}
          handleClose={() => setOpenModal(false)}
          handleSubmit={BorrowalReturn}
          formContent={<ReturnForm documentId={selectedDocumentName} />}
        />
        <FileDocumentViewModal
          open={viewPdfOpen}
          onClose={() => {
            setViewPdfOpen(false);
            setViewPdfSharePointId("");
          }}
          title={viewPdfTitle}
          sharepointFileId={viewPdfSharePointId}
          accessToken={cookies.accessToken}
          fileType={viewPdfTitle === "Summarized Document" ? "txt" : "pdf"}
        />
        <DocumentModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          metadata={selectedMetadata}
          metadataFields={[
            { key: "document_name", label: "File Name" },
            { key: "state_name", label: "State" },
            { key: "location_name", label: "Location" },
            { key: "site_name", label: "Site" },
            { key: "uploaded_at", label: "Upload Date" },
            { key: "box_number", label: "Box No" },
            { key: "unique_survey_no", label: "Survey No" },
            { key: "os_number", label: "OS Number" },
            { key: "document_category", label: "Document Category" },
            { key: "document_type", label: "Document Type" },
            {
              key: "document_copy_type",
              label: "Document Classification",
            },
            { key: "entity_name", label: "Entity" },
            { key: "building_name", label: "Building Name" },
            { key: "saledeed_no", label: "Sale Deed No" },
            { key: "seller_name", label: "Seller Name" },
            { key: "purchase_date", label: "Purchase Date" },
            { key: "lease_deed_date", label: "Lease Deed Date" },
            { key: "lease_no", label: "Lease No" },
            { key: "start_year", label: "Start Year" },
            { key: "end_year", label: "End Year" },
            { key: "valid_until", label: "Valid Until" },
            { key: "receipt_number", label: "Receipt Number" },
            { key: "khata", label: "Khata" },
            { key: "amount", label: "Amount(Rs.)" },
            { key: "cnr_number", label: "CNR Number" },
            { key: "other_document_title", label: "Other Document Title" },
            {
              key: "other_document_description",
              label: "Other Document Description",
            },
            {
              key: "reference_document_title",
              label: "Reference Document Title",
            },
            {
              key: "reference_document_description",
              label: "Reference Document Description",
            },
            {
              key: "grand_parent_document_title",
              label: "Grand Parent Document Title",
            },
            {
              key: "grand_parent_document_description",
              label: "Grand Parent Document Description",
            },
            { key: "parent_document_title", label: "Parent Document Title" },
            {
              key: "parent_document_description",
              label: "Parent Document Description",
            },
          ]}
        />

        {loading && <Spinner />}

        <StatusModal
          isOpen={isModalOpen}
          onClose={() => setisModalOpen(false)}
          message={responseMessage}
          isSuccess={isSuccess}
        />
        <TranslationModal
          open={translationOpen}
          onClose={() => {
            if (existingTranslationPreviewUrl) {
              URL.revokeObjectURL(existingTranslationPreviewUrl);
            }

            setTranslationOpen(false);
            setSelectedDocumentId(null);
            setTranslationPreviewUrl("");
            setExistingTranslationPreviewUrl("");
          }}
          previewUrl={translationPreviewUrl}
          translationAccepted={
            responseData.find((item) => item.document_id === selectedDocumentId)
              ?.translation_accepted === true &&
            translationJobs[selectedDocumentId]?.status !== "done"
          }
          existingTranslationPreviewUrl={existingTranslationPreviewUrl}
          onRetranslate={() => {
            if (selectedDocumentId) {
              const document = responseData.find(
                (item) => item.document_id === selectedDocumentId,
              );

              handleTranslateAgain(
                selectedDocumentId,
                document?.document_name || "",
              );
            }
          }}
          onAccept={() => handleTranslationDecision("Accept")}
          onReject={() => handleTranslationDecision("Reject")}
        />

        <SummaryModal
          open={summaryOpen}
          onClose={() => {
            setSummaryOpen(false);
            setSummaryResponse(null);
            setSelectedDocumentId(null);
          }}
          summaryResponse={summaryResponse}
          summaryAccepted={
            responseData.find((item) => item.document_id === selectedDocumentId)
              ?.summary_accepted === true &&
            summaryJobs[selectedDocumentId]?.status !== "done"
          }
          documentId={selectedDocumentId}
          accessToken={cookies.accessToken}
          onResummarize={() => {
            if (selectedDocumentId) {
              const document = responseData.find(
                (item) => item.document_id === selectedDocumentId,
              );

              handleSummaryAgain(
                selectedDocumentId,
                document?.document_name || "",
              );
            }
          }}
          onAccept={() => handleSummaryDecision("Accept")}
          onReject={() => handleSummaryDecision("Reject")}
        />

        <CourtHistoryModal
          open={openHistoryModal}
          onClose={() => setOpenHistoryModal(false)}
          os_number={selectedOsNumber}
        />
      </div>
    </>
  );
};

export default File;
